import type { HelpFile } from '../../types/help'
import { DelegationsTestIds } from '../../../testids/DelegationsTestIds'

export const delegationsHelp: HelpFile = {
  docPage: '/docs/my-iam/delegations',
  texts: {
    [DelegationsTestIds.delegationsList]:
      'Genehmigungsdelegierungen ermöglichen die vorübergehende Übertragung der Genehmigungsbefugnis an Kolleginnen oder Kollegen bei Abwesenheit.',
  },
}
